<template>
    <div v-if="model" class="my-auto" :class="classContainer">
        <deposit-attachment
            v-if="model.invoice.payment_method === 'deposito'"
            v-model="model"
            :invoiceId="model.invoice.id"
        />
        <div ref="div-card" :class="classCard">
            <h1 class="px-3 py-2 mb-0">
                <i class="mdi mdi-basket mr-3"></i>
                {{ $t('order.order') }}
            </h1>
            <div class="d-flex flex-wrap">
                <div class="col-12 pt-3 bg-li">
                    <h3>{{ $t('order.info') }}</h3>
                </div>
                <div class="px-3 p-4 col-12">
                    <ul class="list-unstyled">
                        <li v-show="model.invoice.total">
                            <span class="font-weight-bolder">
                                {{ $t('order.value') }}:
                            </span
                            ><span>{{
                                formatValue(
                                    model.invoice.value,
                                    model.invoice.currency
                                )
                            }}</span>
                        </li>
                    </ul>
                    <div class="flex">
                        <i
                            :class="[statusInvoice(model.invoice.status).icon,
                            statusInvoice(model.invoice.status).class]"
                        />
                        <span class="status">{{statusInvoice(model.invoice.status).name}}</span>
                    </div>
                </div>
                <div class="col-12 pt-3 pb-3 bg-li" v-if="model.gateways.length">
                    <div v-if="model.recurrence && showLink" class="row">
                        <div class="col-8">
                            <h3>{{ $t('billing.recurrence.payment_type') }}</h3>
                            <div class="control ml-4">
                                <div
                                    v-for="gate in model.gateways"
                                    :key="gate.id"
                                    class="custom-control custom-radio"
                                >
                                    <input
                                        type="radio"
                                        v-model="gateway"
                                        :value="gate"
                                        :id="gate.slug"
                                        :name="$t('cart.payment_type')"
                                        class="custom-control-input"
                                        v-validate="'required'"
                                    />
                                    <label
                                        class="custom-control-label"
                                        :for="gate.slug"
                                    >
                                        {{ gate.name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <template v-if="gateway">
                                <h3>{{ $t('cart.currency') }}</h3>
                                <div class="control ml-4">
                                    <div
                                        v-for="code in gateway.currencies"
                                        :key="code"
                                        class="custom-control custom-radio"
                                    >
                                        <input
                                            type="radio"
                                            v-model="currency"
                                            :value="code"
                                            :id="code"
                                            :name="$t('cart.currency')"
                                            class="custom-control-input"
                                            v-validate="'required'"
                                        />
                                        <label
                                            class="custom-control-label"
                                            :for="code"
                                            >{{ code }}</label
                                        >
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-12 m-1">
                    <div class="d-flex justify-content-between py-3">
                        <a
                            href="/app/dashboard"
                            class="btn btn-warning"
                        >
                            {{ $t('order.go_to_dashboard') }}
                        </a>
                        <button
                            v-if="model.recurrence && showLink"
                            @click="linkRecurrence"
                            class="btn btn-success"
                        >
                            {{ $t('order.link_recurrence') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Currency from '../mixins/currency';
import Invoice from '../mixins/invoice';

import BasePagination from '../argon/components/BasePagination';
import DepositAttachment from '../components/Common/DepositAttachment';

export default {
    name: 'Order',
    components: {
        BasePagination,
        DepositAttachment,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            meta: {
                last_page: 1,
                current_page: 1,
                to: 1,
                total: 1,
                from: 1,
            },
            gateway: null,
            model: this.value,
            currency: '',
            showLink: false,
        };
    },
    mixins: [Currency, Invoice],
    watch: {
        currency(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                this.$loading.show();
                this.$store.dispatch('CHANGE_CURRENCY', {
                    code: newVal,
                });
                window.axios
                    .get(
                        `/api/app/recurrences/${this.model.recurrence.id}/currency/?code=${newVal}`,
                    )
                    .then((res) => {
                        this.$loading.close();
                        if (res.data) {
                            this.model.recurrence.value =
                                res.data.recurrence.value;
                            this.model.recurrence.currency =
                                res.data.recurrence.currency;
                        }
                    })
                    .catch(console.error)
                    .finally(() => this.$loading.close());
            }
        },
    },
    computed: {
        classContainer() {
            const smallScreen = this.$mq === 'sm' || this.$mq === 'md';
            return smallScreen ? 'container-fluid' : 'container';
        },
        classCard() {
            return this.$mq !== 'sm' && 'card nch--cart';
        },
    },
    methods: {
        linkRecurrence() {
            this.$loading.show();
            this.$validator.validateAll().then((result) => {
                if (result) {
                    if (this.plans && this.gateway.slug === 'gerencia-net') {
                        let plansRecurrence = 0;
                        this.plans.forEach((plan) => {
                            if (parseInt(plan.type, 10) === 4) {
                                plansRecurrence += 1;
                            }
                        });

                        if (plansRecurrence > 1) {
                            this.$notify({
                                type: 'danger',
                                message: this.$t(
                                    'cart.recurrence.payment_alert',
                                ),
                            });
                            this.$loading.close();
                            return;
                        }
                    }
                    window.axios
                        .post(
                            `/api/app/recurrences/${this.model.recurrence.id}/associate/gateway`,
                            {
                                slug: this.gateway.slug,
                            },
                        )
                        .then((res) => {
                            location.href = res.data.url;
                        })
                        .catch(console.error)
                        .finally(() => this.$loading.close());
                    return;
                }
                const payment = this.errors.first(this.$t('cart.payment_type'));
                const currency = this.errors.first(this.$t('cart.currency'));
                if (payment) {
                    this.$notify({
                        type: 'danger',
                        message: payment,
                    });
                }
                if (currency) {
                    this.$notify({
                        type: 'danger',
                        message: currency,
                    });
                }
                this.$loading.close();
            });
        },
    },
};
</script>

<style scoped>
.bg-li {
    background: #f6f9fc;
    border: 1px solid #e9ecef;
}

.nch--cart {
    width: 90%;
    margin: auto;
    margin-top: 40px;
    margin-bottom: 40px;
}
.flex {
    display: flex;
    align-items: center;
}
.flex p {
    margin-bottom: 0;
}
</style>
